module.exports = __webpack_public_path__ + "img/customer-3.3fea7b83.png";